// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { Grid, styled, Typography } from "@3778.care/goban";
import PropTypes from "prop-types";

import { useTheme } from "../../../../contexts/theme";
import { dateIsToday, dayInPast, formatByToken } from "../../../../util/date";

const StyledGrid = styled(Grid, {
  shouldForwardProp: (prop) =>
    !["dayInPast", "dateIsToday", "isSpecialTheme"].includes(prop),
})(
  ({
    dayInPast,
    dateIsToday,
    isSpecialTheme,
    theme: { breakpoints, palette, spacing },
  }) => ({
    alignItems: "center",
    borderRadius: spacing(1),
    height: spacing(7),
    justifyContent: "center",
    textTransform: "uppercase",
    width: spacing(6.25),
    [breakpoints.up("md")]: {
      width: spacing(8.75),
      height: spacing(10.25),
    },
    ...(dayInPast && {
      background: palette.grey[200],
      color: palette.text.disabled,
    }),
    ...(dateIsToday && {
      backgroundColor: palette.secondary.background,
      color: palette.secondary.dark,
    }),
    ...(!dayInPast &&
      !dateIsToday && {
        backgroundColor: palette.primary.background,
        color: isSpecialTheme ? palette.secondary.light : palette.primary.dark,
      }),
  })
);

export const DateContainer = ({ start }) => {
  const appointmentDay = formatByToken(start, "dd");
  const appointmentMonth = formatByToken(start, "MMM");
  const { isSpecialTheme } = useTheme();

  return (
    <StyledGrid
      dayInPast={dayInPast(start)}
      dateIsToday={dateIsToday(start)}
      isSpecialTheme={isSpecialTheme}
      container
      direction="column"
    >
      <Typography variant="h4">{appointmentDay}</Typography>
      <Typography component="h6" variant="subtitle2">
        {appointmentMonth}
      </Typography>
    </StyledGrid>
  );
};

DateContainer.propTypes = {
  start: PropTypes.string.isRequired,
};
